module.exports = __webpack_public_path__ + "static/media/kid3.75ead5b0.jpg";